import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-privacy-policy-modal',
  templateUrl: './privacy-policy-modal.component.html',
  styleUrls: ['./privacy-policy-modal.component.scss'],
})
export class PrivacyPolicyModalComponent {
  @Input() useAccountContent = false;

  public currentHeaderData: any = {
    modalSlotEnd: true,
    title: 'Privacy Policy',
    marl20: true,
    mart4: true,
  };

  constructor(
    private modalController: ModalController,
    private analyticsService: AnalyticsService
  ) {}

  closeModal() {
    this.analyticsService.trackUnified('privacy_closed', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'Privacy Policy Closed',
      button: 'privacy-policy-button',
    });
    this.modalController.dismiss();
  }
}
